import config, {axiosConfig} from "../config";
import {default as axios} from "./axiosConfig";

export async function getSnippetByName(name: string) {
    const {data} = await axios.get(`${config.API_URL}/snippet/get-snippet/${name}`, axiosConfig);
    return data;
}